"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PinoutAssertions = exports.PinoutPackagePinMapped = exports.PinoutDesignPinMatchesPackagePin = exports.PinoutDesignSignalMapped = exports.PinoutRequirement = void 0;
const enums_1 = require("../enums");
const PINOUT_REQUIREMENT_ID = 'req_cadstrompinout0000000000000000000000';
exports.PinoutRequirement = {
    id: PINOUT_REQUIREMENT_ID,
    slug: 'cadstrom.pinout',
    slugPrefix: 'PINOUT',
    name: 'Pinout',
    description: 'Asserts that each design signal is mapped to a package signal, that the design pins match the package pins for that signal, and that every package pin is represented by a design signal. Evaluated once per component instance.',
};
exports.PinoutDesignSignalMapped = {
    id: 'asrt_pinoutdesignmapped000000000000000000',
    slug: 'cadstrom.pinout.design_signal.mapped',
    requirementDefinitionId: PINOUT_REQUIREMENT_ID,
    name: 'Design signal must be mapped to a package signal',
    description: 'A design signal on a package-backed component must map to a package-store signal.',
    lifecycle: enums_1.AssertionDefinitionLifecycle.Active,
};
exports.PinoutDesignPinMatchesPackagePin = {
    id: 'asrt_pinoutpinmatch0000000000000000000000',
    slug: 'cadstrom.pinout.design_pin.matches_package_pin',
    requirementDefinitionId: PINOUT_REQUIREMENT_ID,
    name: 'Design pin must match its mapped package pin',
    description: 'When a design signal maps to a package-store signal, the design pin number must match the package pin number for that signal.',
    lifecycle: enums_1.AssertionDefinitionLifecycle.Active,
};
exports.PinoutPackagePinMapped = {
    id: 'asrt_pinoutpackagemapped00000000000000000',
    slug: 'cadstrom.pinout.package_pin.mapped',
    requirementDefinitionId: PINOUT_REQUIREMENT_ID,
    name: 'Package pin must be represented by a design signal',
    description: 'A package-store pin that is part of the resolved package pinout must be represented by a design signal mapping.',
    lifecycle: enums_1.AssertionDefinitionLifecycle.Active,
};
exports.PinoutAssertions = [
    exports.PinoutDesignSignalMapped,
    exports.PinoutDesignPinMatchesPackagePin,
    exports.PinoutPackagePinMapped,
];
//# sourceMappingURL=pinout.js.map